<mat-accordion
  class="venue-items-accordion"
  displayMode="flat"
  hideToggle
  multi="true"
>
  <mat-expansion-panel
    class="expansion-panel mat-elevation-z0"
    [expanded]="panelOpenState || hide"
    (afterExpand)="onAfterExpand()"
    (afterCollapse)="onAfterCollapse()"
    (opened)="animateOpenState = true"
    (closed)="animateOpenState = false"
  >
    <mat-expansion-panel-header
      class="venue-items-accordion-header"
      [ngClass]="{ hide: hide }"
    >
      <div
        class="header-content-container"
        [class.opened]="animateOpenState"
        [class.closed]="!panelOpenState"
      >
        <div class="header-content">
          <div class="header-text-container">
            {{ header | uppercase }}
          </div>
          <div class="icon-container">
            <mat-icon [svgIcon]="animateOpenState ? 'minus' : 'plus'"></mat-icon>
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>
    <div class="container">
      <div
        id="visionboard-workspace-venue-items-tutorial-target"
        class="border"
        [ngClass]="{ dragging: dragging, allowDrop: allowDrop, hide: hide }"
      >
        <div
          id="visionboard-workspace-venue-items"
          class="visionboard-workspace-venue-items merri-scrollbar-gray"
        >
          <div
            id="visionboard-workspace-venue-items-message"
            class="message"
            *ngIf="message"
            [ngClass]="{ hideItems: hideItems }"
          >
            {{ message | uppercase }}
          </div>
          <app-visionboard-workspace-item
            *ngFor="let item of items; trackBy: trackWorkspaceItemsFn"
            class="visionboard-venue-item"
            id="visionboard-workspace-item-{{ item.internalId }}"
            [item]="item"
            cdkDrag
            [cdkDragData]="item"
            [cdkDragFreeDragPosition]="item.location"
            [cdkDragDisabled]="true"
            cdkDragBoundary=".visionboard-workspace-venue-items"
            (cdkDragStarted)="onDragStart($event, item)"
            (cdkDragReleased)="onDragReleased($event, item)"
            (cdkDragMoved)="onDragMoved($event, item)"
            [dragging]="dragging"
            [externalDrag]="externalDrag"
            [removable]="false"
            [disableDrag]="true"
            [ngClass]="{ hideItems: hideItems }"
            [sizeFactor]="sizeFactor"
            (click)="onItemClick()"
          ></app-visionboard-workspace-item>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
